module.exports = {
          srcSet: __webpack_public_path__ + "public/images/1432fd9bac3a5a4593947e4bf816d9b9-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/1432fd9bac3a5a4593947e4bf816d9b9-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/1432fd9bac3a5a4593947e4bf816d9b9-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/1432fd9bac3a5a4593947e4bf816d9b9-1774.jpg"},
          
          width: 1774,
          height: 887
        }